/* youthfulbloom - wishlist stars.
   Stores product handles in localStorage. Delegated from document so it
   also covers cards injected later by the tab switcher. */
(function () {
  var KEY = 'yb_wishlist';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (err) {
      return [];
    }
  }

  var saved = read();

  function paint(btn) {
    var on = saved.indexOf(btn.dataset.ybWish) !== -1;
    var icon = btn.querySelector('.yb-star');
    if (icon) icon.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', String(on));
  }

  function paintAll() {
    document.querySelectorAll('[data-yb-wish]').forEach(paint);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yb-wish]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.dataset.ybWish;
    var i = saved.indexOf(handle);
    if (i === -1) { saved.push(handle); } else { saved.splice(i, 1); }

    try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (err) {}
    paint(btn);
  });

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    saved = read();
    paintAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }

  document.addEventListener('shopify:section:load', paintAll);
})();
